/**
 * Used to temporarily persist info about the user's last action across page reloads.
 * Useful when using the URL is undesirable
 */
import noticeError from '../services/noticeError'

const lastActionKey = 'identity:last-action'

const expirationMs = 120000

// use in memory storage to avoid hitting sessionStorage frequently
let lastActionMemoryCache = null

function parseLastUserAction(rawResult, cisId) {
  let result = null
  try {
    result = JSON.parse(rawResult)
  } catch (e) {
    noticeError(e)
    clearLastUserAction()
    return null
  }
  const timestamp = result?.timestamp
  if (timestamp) {
    if (Date.now() - timestamp > expirationMs || cisId !== result?.cisId) {
      clearLastUserAction()
      return null
    }
    lastActionMemoryCache = result?.action
    return lastActionMemoryCache
  }
  return null
}

export function getLastUserAction(cisId) {
  if (lastActionMemoryCache) {
    return lastActionMemoryCache
  }
  if (!cisId) {
    return null
  }
  const rawResult = sessionStorage.getItem(lastActionKey)
  if (!rawResult) {
    return null
  }
  return parseLastUserAction(rawResult, cisId)
}

export function setLastUserAction(action, cisId) {
  lastActionMemoryCache = action
  const value = JSON.stringify({
    action,
    timestamp: new Date().getTime(),
    cisId,
  })
  sessionStorage.setItem(lastActionKey, value)
}

export function clearLastUserAction() {
  lastActionMemoryCache = null
  sessionStorage.removeItem(lastActionKey)
}
